/* eslint-disable @angular-eslint/component-selector */
import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { BadgeModule } from 'primeng/badge';
import { LayoutService } from '@/layout/service/layout.service';
import { SHARED_IMPORTS } from '@/utils/other/standalone-import';
import { ProfileComponent } from '@/components/auth/profile/profile.component';
import { AuthService } from '@/services/auth/auth.service';
import { User } from '@sentry/angular';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';

@Component({
  selector: '[app-profilesidebar]',
  imports: [SHARED_IMPORTS, ButtonModule, DrawerModule, BadgeModule],
  template: ` <p-drawer
    [visible]="visible()"
    (onHide)="onDrawerHide()"
    position="right"
    [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
    styleClass="layout-profile-sidebar w-full sm:w-25rem">
    <div class="flex flex-column mx-auto md:mx-0 pt-4">
      <span class="mb-2 font-semibold"
        >{{ 'general.profileSidebar.welcome' | translate }}
        {{ userCredentials }}</span
      >
      <span class="text-color-secondary font-medium mb-5"></span>

      <ul class="list-none m-0 p-0">
        <li>
          <a
            (click)="handleLogout()"
            class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
            <span>
              <i class="pi pi-power-off text-xl text-primary"></i>
            </span>
            <div class="ml-3">
              <span class="mb-2 font-semibold">{{
                'general.profileSidebar.signOut' | translate
              }}</span>
            </div>
          </a>
        </li>
        <li>
          <a
            (click)="viewUserProfile()"
            class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
            <span>
              <i class="pi pi-user text-xl text-primary"></i>
            </span>

            <div class="ml-3">
              <span class="mb-2 font-semibold">{{
                'general.profileSidebar.showProfile' | translate
              }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </p-drawer>`
})
export class AppProfileSidebar implements OnInit, OnDestroy {
  private layoutService = inject(LayoutService);
  private authService = inject(AuthService);
  private dialogService = inject(DialogService);

  user: User | null = null;

  subscriptions = new Subscription();

  constructor() {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.authService.user$.subscribe((user) => {
        if (user) {
          this.user = user;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get userCredentials(): string {
    if (!this.user) {
      return '';
    }

    return `${this.user['firstname']} ${this.user['lastname']}`;
  }

  visible = computed(
    () => this.layoutService.layoutState().profileSidebarVisible
  );

  onDrawerHide() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      profileSidebarVisible: false
    }));
  }

  handleLogout(): void {
    this.onDrawerHide();
    this.authService.logout();
  }

  viewUserProfile(): void {
    this.onDrawerHide();

    if (!this.user) {
      return;
    }

    this.dialogService.open(ProfileComponent, {
      header: '',
      modal: true,
      width: '40%',
      data: {
        username: this.user.username
      }
    });
  }
}
